import React from 'react'

import SingleInput from '../Fields/SingleInput'

const ModuleOne = (props) => {
	return (
		<div>
			<SingleInput 
				controlFunc={props.addToForm}
				name={"patientName"}
				inputType={"text"}
				placeholder={"Patient's Name"}
				value={props.consentForm.patientName}
			/>
			<SingleInput
				controlFunc={props.addToForm}
				name={"currentDate"}
				inputType={"date"}
				value={props.consentForm.currentDate}
			/>
		</div>
	)
}

export default ModuleOne


// WEBPACK FOOTER //
// ./src/components/Modules/1.js